import { Trans } from "@lingui/react";
import type { MobilityAd } from "@mobility-item-page/types";
import { ElementType, Intent, TargetType } from "@mobility-item-page/utilities/client";
import usePulse from "src/utils/pulse-tracking/usePulse.ts";
import { hasDeclartionOfGoods } from "src/utils/safetyElements.ts";

type Props = {
  ad: MobilityAd;
};
const DeclarationOfGoods = ({ ad }: Props) => {
  const { trackClick } = usePulse();

  if (hasDeclartionOfGoods(ad)) {
    return (
      <>
        <Trans
          id="itemPageLayout.safetyElement.declarationOfGoods.info"
          message="The car is sold with an approved product declaration. This means that the condition of the car is documented in writing, giving you as the buyer confirmation that the car is in the condition you were promised."
        />
        <a
          href={ad.declaration_of_goods}
          className="block mt-16 md:mt-8"
          target="_blank"
          rel="noopener"
          onClick={() =>
            // Tracking event: MO_ev92
            trackClick({
              name: "Read Declaration of Goods",
              objectId: "MO_ev92",
              elementType: ElementType.Link,
              intent: Intent.Open,
              target: {
                id: ad.declaration_of_goods || "",
                type: TargetType.Article,
                name: "Declaration of Goods",
              },
            })
          }
        >
          <Trans id="itemPageLayout.safetyElement.declarationOfGoods.link" message="Declaration of goods" />
        </a>
      </>
    );
  }
  return null;
};

export default DeclarationOfGoods;
